import React from 'react';
import PageHeader from '../finance/components/ui/PageHeader';
import OnboardingModal from './OnboardingModal';

export default function OnboardingPage() {
  return (
    <div className="max-w-7xl mx-auto p-4 sm:p-6 animate-fade-in pb-20 space-y-6">
      <div className="no-print">
        <PageHeader
          title="Employee Onboarding Documents"
          description="Download official company blank templates, upload your completed signed documents, and submit for verification."
        />
      </div>

      <OnboardingModal overrideOpen={true} isEmbedded={true} />
    </div>
  );
}
